import { ServiceName } from "types/graphql";

export type UserSettings = {
  hasEmailNotification?: boolean;
  hasSlackNotification?: boolean;
  timeZone?: string;
  language?: string;
  createTaskShortcut?: string;
  createNoteShortcut?: string;
  location?: {
    region?: string;
    city?: string;
    country?: string;
    timezone?: string;
    postal?: string;
  };
};

export type T_Transcript = {
  _id: string;
  meetingId?: string;
  summary: string;
  detailedSummary: string;
  meetingTitle?: string;
  meetingDate?: Date;
  created: Date;
  transcript?: string;
};
export type TranscriptsResponse = {
  transcripts: T_Transcript[];
};
export type TranscriptResponse = {
  transcript: T_Transcript;
};

export interface User {
  _id: string;
  firstName?: string;
  lastName?: string;
  profileUrl?: string;
  email: string;
  created: Date;
  settings?: UserSettings;
  creditBalance?: number;
  firstSubscriptionAt?: Date;
  invalidGrant?: boolean;
  rateLimitExceeded?: boolean;
  partialAccount?: boolean;
  hasGmail?: boolean;
  hasCalendar?: boolean;
  hasZoom?: boolean;
  services?: ServiceName[];
  tempLocation?: string;
  stripeCustomerId?: string;
  vipUser?: boolean;
  preferences?: {
    location?: string;
    secondaryLocation?: string;
    language?: string;
    timezone?: string;
    firstName?: string;
    lastName?: string;
    lastChanged: Date;
    emailSignature?: string;
  };
  notifications?: {
    hasNotification: boolean;
    morningSummary: boolean;
    notSendIfNoEvents: boolean;
    endOfDayNotification: boolean;
    endOfWeekNotification: boolean;
    sundayNotification: boolean;
    timeToReceivePrep: number;
  };
}

export type SubscriptionResponse = {
  currentSubscription: Subscription;
};
export interface Subscription {
  plan: string;
  startAt?: Date;
  endAt?: Date;
  autoRenew: boolean;
  isTrial: boolean;
  billingCycle?: string;
  canceledAt?: Date;
}

export enum E_UserAction {
  SET_USER,
  SET_CURRENT_EMAIL,
  CLEAR,
}

export type T_Podcast = {
  type: "daily" | "weekly";
  title?: string;
  url: string;
  chapter?: string;
  transcript?: string;
  audioDuration?: number;
  created: Date;
};

export interface PodcastResponse {
  podcasts: T_Podcast[];
}

export type T_Todo = {
  _id: string;
  title: string;
  source: string;
  sourceId?: string;
  created: Date;
  dueDate: Date;
  url?: string;
  priority: number;
};
export type TodosResponse = {
  todos: T_Todo[];
};
